import React from 'react';
import { Link } from 'react-router-dom';

const aiServices = [
  { icon: '🧠', title: 'AI Strategy & Consulting', desc: 'Expert guidance on integrating AI into your business strategy for measurable ROI and competitive advantage. We assess your current state, identify AI opportunities, and build a roadmap.' },
  { icon: '⚙️', title: 'Machine Learning Solutions', desc: 'Custom ML models trained on your data to predict, classify, and automate complex business decisions. From regression models to deep neural networks.' },
  { icon: '✨', title: 'Generative AI Integration', desc: 'Embed LLMs and generative AI into your products and workflows for content creation, code generation, and creative tasks using GPT, Claude, and open-source models.' },
  { icon: '🤖', title: 'AI-Powered Automation', desc: 'Intelligent process automation using AI agents to reduce manual work, eliminate errors, and increase operational efficiency across your organization.' },
  { icon: '💬', title: 'Natural Language Processing', desc: 'Conversational AI, chatbots, sentiment analysis, document intelligence, and text summarization for smarter customer and employee interactions.' },
  { icon: '👁️', title: 'Computer Vision', desc: 'Image recognition, object detection, facial recognition, and visual analytics for quality control, surveillance, and document processing.' },
  { icon: '📊', title: 'AI Data Analytics', desc: 'Advanced analytics powered by AI to uncover hidden patterns, forecast trends, and deliver actionable business intelligence from your data.' },
];

const process = [
  { step: '01', title: 'Discovery', desc: 'Understand your business goals and identify AI opportunities.' },
  { step: '02', title: 'Strategy', desc: 'Develop a tailored AI roadmap and select the right technologies.' },
  { step: '03', title: 'Development', desc: 'Build, train, and validate custom AI models.' },
  { step: '04', title: 'Deployment', desc: 'Integrate AI solutions into your existing systems.' },
  { step: '05', title: 'Optimization', desc: 'Monitor, retrain, and continuously improve performance.' },
];

const AIServices = () => (
  <>
    {/* Hero */}
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0c1445 100%)', position: 'relative', overflow: 'hidden' }}>
      <div className="container py-5">
        <span className="badge px-3 py-2 mb-3" style={{ background: 'rgba(99,102,241,0.3)', color: '#c7d2fe', fontSize: 12, letterSpacing: 1 }}>✨ NEWLY LAUNCHED</span>
        <h1 className="fw-bold display-4 mb-3">AI Services & Solutions</h1>
        <p className="lead mb-4" style={{ color: '#94a3b8', maxWidth: 600, margin: '0 auto 24px' }}>
          Harness the power of artificial intelligence to transform your business. From strategy to deployment, EGB delivers intelligent solutions that scale.
        </p>
        <Link to="/contact" className="btn btn-lg fw-bold px-5" style={{ background: 'linear-gradient(135deg, #6366f1, #0ea5e9)', color: '#fff', border: 'none' }}>
          Schedule an AI Consultation ✨
        </Link>
      </div>
    </section>

    {/* Why AI */}
    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Why AI for Your Business?</h2>
          <p className="text-muted">Artificial Intelligence is revolutionizing how businesses operate.</p>
        </div>
        <div className="row g-4 text-center">
          {[{ icon: '⚡', title: 'Increased Efficiency', desc: 'Automate repetitive tasks and free your team for high-value work.' }, { icon: '📈', title: 'Better Insights', desc: 'Uncover patterns and trends hidden in your data.' }, { icon: '💰', title: 'Cost Reduction', desc: 'Reduce operational costs through intelligent automation.' }, { icon: '🎯', title: 'Competitive Edge', desc: 'Stay ahead with AI-powered products and services.' }].map((b, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100 p-4">
                <div style={{ fontSize: 40 }} className="mb-3">{b.icon}</div>
                <h6 className="fw-bold">{b.title}</h6>
                <p className="text-muted small mb-0">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* AI Services Grid */}
    <section className="py-5" style={{ background: 'linear-gradient(135deg, #0f172a, #1e1b4b)' }}>
      <div className="container py-4">
        <div className="text-center mb-5">
          <h2 className="fw-bold text-white">Our AI Services</h2>
          <p style={{ color: '#94a3b8' }}>End-to-end AI solutions tailored to your needs</p>
        </div>
        <div className="row g-4">
          {aiServices.map((s, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-4">
              <div className="h-100 p-4 rounded-4 position-relative" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <span className="badge position-absolute top-0 end-0 m-3" style={{ background: 'linear-gradient(90deg,#6366f1,#0ea5e9)', fontSize: 9 }}>NEW</span>
                <div style={{ fontSize: 40 }} className="mb-3">{s.icon}</div>
                <h5 className="fw-bold text-white mb-2">{s.title}</h5>
                <p style={{ color: '#94a3b8', fontSize: 14 }}>{s.desc}</p>
                <Link to="/contact" className="text-decoration-none" style={{ color: '#38bdf8', fontSize: 13, fontWeight: 600 }}>Get started →</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Process */}
    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Our AI Implementation Process</h2>
        </div>
        <div className="row g-4 justify-content-center">
          {process.map((p, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-2 text-center">
              <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3 fw-bold text-white" style={{ width: 56, height: 56, background: 'linear-gradient(135deg,#1a56db,#0ea5e9)', fontSize: 18 }}>{p.step}</div>
              <h6 className="fw-bold">{p.title}</h6>
              <p className="text-muted small">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #6366f1, #0ea5e9)' }}>
      <div className="container py-4">
        <h2 className="fw-bold mb-3">Ready to Embrace AI?</h2>
        <p className="lead mb-4">Let's discuss how AI can transform your business.</p>
        <Link to="/contact" className="btn btn-light btn-lg fw-bold px-5">Schedule a Consultation →</Link>
      </div>
    </section>
  </>
);

export default AIServices;
